import { render, staticRenderFns } from "./GreFeedback.vue?vue&type=template&id=2237fc6b&scoped=true&"
import script from "./GreFeedback.vue?vue&type=script&lang=js&"
export * from "./GreFeedback.vue?vue&type=script&lang=js&"
import style0 from "./GreFeedback.vue?vue&type=style&index=0&id=2237fc6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2237fc6b",
  null
  
)

export default component.exports